import { server } from "../globalSettings";


export const requestAuthOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
        };
        return requestOptions
    }

}
// api
// export const profileApi = async (page) => {
//     const request = requestAuthOption("GET")
//     try {
//         const response = await fetch(`${server}company_profile/1`, request);
//         const data = await response.json();
//         return new Promise(function (resolve, reject) {
//             setTimeout(function () {
//                 if (response.ok) {
//                     if (data.code === "success") {
//                         resolve(data.data);
//                     } else {
//                         reject(["No data"]);
//                     }
//                 } else {
//                     reject(["Something went wrong, please try again later"]);
//                 }
//             });
//         });
//         // if (response.ok) {
//         //     const data = await response.json(); // Parse JSON data
//         //     if (data.code === "success") {
//         //         return data; // Return the data
//         //     } else {
//         //         apiError("Username and password are invalid. Please enter correct username and password");
//         //         return false; // Custom error message
//         //     }
//         // } else {
//         //     throw new Error('Network response was not ok');
//         // }
//     } catch (error) {
//         return new Promise(function (resolve, reject) {
//             setTimeout(function () {
//                 reject(["Network response error, please try again later"]);
//                 // throw error;
//             })
//         })

//     }
// };

export const updateProfile = async ({profile}) => {
    const request = requestAuthOption("PUT", profile)
    try {
        const response = await fetch(`${server}profile`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const updateProfilePW = async ({profile}) => {
    const request = requestAuthOption("PUT", profile)
    try {
        const response = await fetch(`${server}profile/password`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};